<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <PublicLandingHeader
      title="Hazardous Waste System"
      subtitle="Hawaii State Environmental Health Administration Solid and Hazardous Waste Branch"
      light
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop light class="grid grid-cols-1 gap-10">
        <PublicLandingOnlineServices
          class=""
          title="Internal Services"
          body="The Hazardous Waste System provides online employee access to hazardous waste handler information managed in the Resource Conservation and Recovery Act Information (RCRAInfo) system. Handlers include all generators, transporters, treaters, storers, and disposers of hazardous waste."
          hide-register
        ></PublicLandingOnlineServices>
        <PublicLandingCard>
          <PublicLandingCardSection label="Handlers">
            <PublicLandingParagraph>Find and view hazardous waste handlers.</PublicLandingParagraph>
            <PublicLandingList>
              <PublicLandingListItem label="Activities, waste codes, and industry classifications" />
              <PublicLandingListItem label="Permits" />
              <PublicLandingListItem label="Corrective actions" />
              <PublicLandingListItem label="Evaluations" />
              <PublicLandingListItem label="Violations" />
              <PublicLandingListItem label="Enforcement actions" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>
    <MdrnFooter black-and-white />
  </div>
</template>

<script lang="ts">
import { InitialBadge } from "@modernary/mui/components/badge";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppNav, useAppSettingsStore } from "@modernary/mui/components/common";
import { LoginButton, LogoutButton, RegisterButton } from "@modernary/mui/utils/authentication/buttons";
import { useUser } from "@modernary/mui/utils/authentication";

import { defineComponent } from "vue";
import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingLinkCard,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { BaseButton, appSettingsStore };
  },
  components: {
    BaseButton,
    InitialBadge,
    LoginButton,
    LogoutButton,
    MdrnFooter,
    RegisterButton,
    PublicLandingBackdrop,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingContainer,
    PublicLandingHeader,
    PublicLandingLinkCard,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingOnlineServices,
    PublicLandingParagraph,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #10113e; /* average color from the sky of the bg */
  background-image: url("/images/bg-public.jpg");
  background-size: cover;
  background-position: center 0;
  background-repeat: no-repeat;
}
</style>
